import styled from "styled-components";
import customMedia from "../../config/breakpoints";

export const LayoutContainer = styled.div`
  align-items:center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background ${({ theme }) => theme.colors.background};
  padding: 3rem 15rem;

  ${customMedia.lessThan("tablet")`
     padding: 1.2rem 5.625rem;
  `}

  ${customMedia.lessThan("mobile")`
     padding: 1.2rem 2rem;
  `}

`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`;

export const RightContainer = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  width: 50%;
  justify-content: flex-end;

  ${customMedia.lessThan("mobile")`
    justify-content: flex-start;
    padding-top:8px;
  `}
`;

export const LeftContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  width: 50%;
  gap: 50px;
  padding-bottom: 16px;

  ${customMedia.lessThan("mobile")`
    padding-bottom: 0px;
    padding-top: 16px;
  `}
`;

export const UrgencyContainer = styled.div`
  margin-top: 80px;
  width: 100%;
`;
